export const userField = {
  LOCATION: 'location',
  CATEGORIES: 'categories',
  LANGUAGES: 'languages',
  PROFILE_VIDEO: 'profileVideo',
};
